export const dropdownComponentIds = {
  DropdownOverlay: 'DropdownOverlay',
  Dropdown: 'Dropdown',
  BaseBox: 'BaseBox',
  triggers: {
    SelectInput: 'SelectInput',
    DropdownButton: 'DropdownButton',
    DropdownLink: 'DropdownLink',
    AutoComplete: 'AutoComplete',
    SearchInput: 'SearchInput',
    DropdownIconButton: 'DropdownIconButton',
    FilterChipSelectInput: 'FilterChipSelectInput',
    InputDropdownButton: 'InputDropdownButton',
  },
};
